module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.categoryList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無商品分類，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    domProps: {
      "textContent": _vm._s('新增')
    },
    on: {
      "click": _vm.gotoCrCategories
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.categoryList), function(category, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === category.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === category.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickCategory(category, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(category.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.name),
      expression: "categoryInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.categoryInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.sort),
      expression: "categoryInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.categoryInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.remark),
      expression: "categoryInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.categoryInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.description),
      expression: "categoryInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.categoryInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryInfo.vendor_custom_id),
      expression: "categoryInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.categoryInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.categoryInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseProdModal"
    }
  }, [_vm._v("\n                  選擇商品\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.productList), function(prod) {
    return (prod.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(prod.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("套餐")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block ",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#chosePackModal"
    }
  }, [_vm._v("\n                  選擇套餐\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.packageList), function(pack) {
    return (pack.active) ? _c('div', {
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(pack.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.categoryList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrCategories
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty()
      }
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.productList,
      "option": _vm.choseProduct
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-modal', {
    attrs: {
      "elementList": _vm.packageList,
      "option": _vm.chosePackage
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        商品分類\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("分類名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14805399"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrCategoryTemp.vue
// module id = 2328
// module chunks = 1